module.exports = __webpack_public_path__ + "static/media/20210101.108a1234.jpg";